export const NFT_LOAD_REQUEST = 'NFT_LOAD_REQUEST'
export const NFT_LOAD_SUCCESS = 'NFT_LOAD_SUCCESS'
export const NFT_LOAD_FAIL = 'NFT_LOAD_FAIL'
export const NFT_LOAD_RESET = 'NFT_LOAD_RESET'
